export default __webpack_public_path__ + "static/Facebook-eaa55e428dfcc364dc67c08387fd50c2.jpg";